import { requestByGET } from 'lib/requests'
import { buildPathParams } from 'lib/utils/url'
import { mapReviews } from './mappers'
import { TOO_MANY_REQUESTS } from 'src/constants/httpcodes'
import { TripReasonFilter } from './constants'

const END_POINTS = {
  REVIEWS: '/v2/reviews/location/{propertyId}',
}

export interface FetchReviewsPayload {
  language: string
  propertyId: number
  page: number
  size?: number
  tripReason?: TripReasonFilter
}

interface Error {
  error: {
    message: string
  }
}
interface FetchReviewsResponseSuccess {
  status: 200
  data: ReturnType<typeof mapReviews>
}

interface FetchReviewsErrorResponse {
  status: typeof TOO_MANY_REQUESTS.status
  data: Error
}

export type FetchReviewsResponse = FetchReviewsResponseSuccess | FetchReviewsErrorResponse

export async function fetchReviews(params: FetchReviewsPayload): Promise<FetchReviewsResponse> {
  const { propertyId, language, page, tripReason, size = 5 } = params

  const info = await requestByGET({
    data: { lang: language, size, page, trip_reason: tripReason },
    endpoint: buildPathParams(END_POINTS.REVIEWS, { propertyId }),
    mapper: mapReviews,
  })

  if (info.status === 404) {
    return { data: mapReviews(info.data), status: 200 }
  }

  return info
}
